export default __webpack_public_path__ + "static/media/01.19b94b2b.jpg";